import { baseApi, TAG } from '../../app/api/baseApi'

const pick = (source, keys) => {
    const key = keys.find((name) => source[name] !== undefined && source[name] !== null && source[name] !== '')
    return key ? source[key] : null
}

const asList = (data) => {
    if (Array.isArray(data)) return data
    if (data && Array.isArray(data.data)) return data.data
    if (data && Array.isArray(data.items)) return data.items
    return []
}

const ISO_UTC = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)\s*(?:UTC|Z)?$/i

const parseTimestamp = (value) => {
    if (!value) return null
    const text = String(value).trim()
    const match = text.match(ISO_UTC)
    const date = new Date(match ? `${match[1]}Z` : text)
    return Number.isNaN(date.getTime()) ? null : date.toISOString()
}

const parseMessage = (message) => {
    const text = String(message || '').trim()
    const lead = text.match(/^(.*?)\s+for\s+([A-Z][\w ]*:\s.*)$/)
    const body = lead ? lead[2] : text
    const pairs = body.split(/,\s*(?=[A-Z][\w ]*:\s)/).map((part) => {
        const index = part.indexOf(': ')
        return index > 0 ? { label: part.slice(0, index).trim(), value: part.slice(index + 2).trim() } : null
    })
    if (pairs.length < 2 || pairs.some((pair) => !pair)) {
        return { summary: null, details: [] }
    }
    return {
        summary: lead ? lead[1] : null,
        details: pairs.map((pair) => {
            const date = /time|date/i.test(pair.label) ? parseTimestamp(pair.value) : null
            return { ...pair, date }
        })
    }
}

export const normalizeNotification = (item, index) => {
    const message = pick(item, ['message', 'description', 'notificationMessage', 'body', 'content', 'text'])
    const { summary, details } = parseMessage(message)
    const detailDate = details.find((detail) => detail.date)
    return {
        id: pick(item, ['id', 'notificationId', 'notificationDataId']) ?? index,
        title: pick(item, ['title', 'subject', 'notificationTitle']) || summary,
        message: details.length > 0 ? null : message,
        details: details.filter((detail) => detail !== detailDate),
        eventLabel: detailDate ? detailDate.label : null,
        date: parseTimestamp(pick(item, ['createdDate', 'createdOn', 'createdAt', 'notificationDate', 'date', 'modifiedDate'])) || (detailDate ? detailDate.date : null)
    }
}

export const notificationsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getUnreadNotifications: builder.query({
            query: () => '/v2/NotificationData/all/unread',
            transformResponse: (data) => asList(data).map(normalizeNotification),
            providesTags: [TAG.NOTIFICATION]
        })
    })
})

export const { useGetUnreadNotificationsQuery } = notificationsApi
